export default "__VITE_ASSET__mMSAL$Tj__"